import { getIntegrations } from '../../../crud/integration.crud'

export const INTEGRATION_APPS = {
  OFFICE_365: 'Office365',
  DUO_SECURITY: 'DUOSecurity',
  AUTOTASK: 'Autotask',
  SYNCRO: 'Syncro',
  CONNECTWISE: 'ConnectWise',
  HALO: 'Halo',
}

export const INTEGRATION_TYPE = {
  LEGACY: 0, // deprecated powershell credential authentication
  TOKEN: 1, // token based authentication
  APP: 2, // 1 to 1 application to integration model
  CSP: 3, // CSP multi-tenant single app model
}

export const getM365CspIntegration = async ({ parentId }) => {
  let cspIntegration
  try {
    const parentIntegrations = await getIntegrations(parentId)
    cspIntegration = parentIntegrations?.data?.find(
      (integration) =>
        integration?.IntegrationApplication?.application_name === 'Office365' &&
        integration?.integration_type === INTEGRATION_TYPE.CSP,
    )
  } catch (error) {
    console.error('Failed to retrieve parent company integrations', error)
  }

  return cspIntegration ?? null
}

export const PSA_INTEGRATIONS = ['Autotask', 'Halo', 'Syncro', 'ConnectWise']
